import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CalendarDays, ChevronRight, ClipboardList } from 'lucide-react';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';

export default function FeedbackMenu(props: any) {
	const { activeItem, onItemClick } = props;
	const currentFormInFocus = useSelector((state: RootState) => state.feedbackFormInFocus);
	const navigate = useNavigate();

	const menuItem = (label: string, icon: React.ReactNode, onClick: () => void, active: boolean, className: string) => (
		<button
			className={`grid w-full grid-cols-[20%_60%_20%] items-center text-left ${active ? 'rounded-lg border border-blue-400 bg-blue-50' : ''} ${className}`}
			onClick={onClick}
			type="button"
		>
			<span className="flex justify-center">{icon}</span>
			<span className={label === 'Submit New Session' ? 'new-session' : 'previous-session'}>{label}</span>
			<ChevronRight aria-hidden="true" className="mx-auto size-6 text-[#C4C4C4]" />
		</button>
	);

	return (
		<div className="w-full">
			<header className="flex items-center border-b border-gray-200 pb-5 pt-6 md:hidden">
					<button aria-label="Back" className="w-[20.833333%] text-center" onClick={() => navigate('..')} type="button"><ArrowLeft className="mx-auto size-6" /></button>
					<div className="session-feedback w-[79.166667%]">Submit Session Feedback</div>
			</header>
			{menuItem('Submit New Session', <ClipboardList aria-hidden="true" className="size-6 text-[#428ac9]" />, () => navigate('../new-session'), activeItem === 'newSession' && currentFormInFocus === 1, 'grid py-6 md:hidden')}
			{menuItem('Submit New Session', <ClipboardList aria-hidden="true" className="size-6 text-[#428ac9]" />, () => onItemClick('newSession'), activeItem === 'newSession' && currentFormInFocus === 1, 'hidden py-6 md:grid')}
			<div className="mx-auto w-5/6 border-t border-gray-200" />
			{menuItem('Previous Sessions', <CalendarDays aria-hidden="true" className="size-6 text-[#428ac9]" />, () => navigate('../previous-session'), activeItem === 'previousSession', 'grid py-6 md:hidden')}
			{menuItem('Previous Sessions', <CalendarDays aria-hidden="true" className="size-6 text-[#428ac9]" />, () => onItemClick('previousSession'), activeItem === 'previousSession', 'hidden py-6 md:grid')}
		</div>
	);
}
